// @flow
import _ from 'lodash';

import type { TDraftLeaguesReducer } from '../../types';

export const getWaiversListIds = (state: TDraftLeaguesReducer) =>
	_.get(state, 'leagues.waiver_list.ordered_ids', {});

export default getWaiversListIds;